module.exports = __webpack_public_path__ + "static/media/user-nurse.7716a733.svg";